<script>
import projectApi from '@/api/project';
import stageApi from '@/api/stage';
import taskApi from '@/api/task';

import BasePopup from '@/components/BasePopup.vue';
import BaseSelect from '@/components/BaseSelect.vue';

export default {
  name: 'TaskCopyPopup',
  components: { BasePopup, BaseSelect },
  controller: null,
  data() {
    return {
      mode: null,
      sourceId: null,
      sourceData: null,
      isOpened: false,
      projects: [],
      stages: [],
      tasks: [],
      project: null,
      stage: null,
      task: null,
    };
  },
  computed: {
    projectOptions() { return Object.fromEntries(this.projects.map(p => [p.id, p.name])); },
    stageOptions() { return Object.fromEntries(this.stages.map(p => [p.id, p.name])); },
    taskOptions() { return Object.fromEntries(this.tasks.map(p => [p.id, p.name])); },
  },
  watch: {
    async project(val) {
      if (!val) return;
      if (this.mode === 'stage') return;
      const project = await projectApi.fetchItem(val, true);
      this.stages = project.stages ?? [];
      this.stage = null;
      this.task = null;
    },
    async stage(val) {
      if (this.mode !== 'checklist') return;
      const response = await taskApi.fetchList({ isDraft: false, stage: val });
      this.tasks = response.items;
      this.task = null;
    },
  },
  created() {
    projectApi.fetchList({ isArchived: false }, true).then(r => { this.projects = r.items; });
  },
  methods: {
    open(mode, sourceId, sourceData = null) {
      this.mode = mode;
      this.sourceId = sourceId;
      this.sourceData = sourceData;
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.$options.controller.resolve();
      this.isOpened = false;
    },
    async copyStage() {
      const stageData = {
        name: `Копия ${this.sourceData.name}`,
        project: projectApi.getIri(this.project),
      };

      const createdStage = await stageApi.create(stageData, true);
      const stageIri = createdStage['@id'];

      const fetchPromises = [];
      const createPromises = [];
      this.sourceData.tasks.forEach(t => {
        const fetchPromise = taskApi.fetchItem(t.id, {}, true);
        fetchPromises.push(fetchPromise);
        fetchPromise.then(taskData => {
          const { name, description, checklist, priority } = taskData;
          const payload = { name, description, checklist, priority, stage: stageIri };
          createPromises.push(taskApi.create(payload, true));
        });
      });

      await Promise.all(fetchPromises);
      await Promise.all(createPromises);

      const route = { name: 'project-stages', params: { projectId: this.project } };
      this.$router.push(route).catch(() => { this.$router.go(); });
      this.$push({ text: 'Раздел скопирован' });
      this.close();
    },
    async copyTask() {
      const r = await taskApi.fetchItem(this.sourceId, {}, true);
      const { name, description, checklist, priority } = r;
      const payload = { name: `Копия ${name}`, description, checklist, priority, stage: stageApi.getIri(this.stage) };
      const createdTask = await taskApi.create(payload, true);

      const route = { name: 'task-detail', params: { projectId: this.project, stageId: this.stage, taskId: createdTask.id } };
      this.$router.push(route).catch(() => { this.$router.go(); });
      this.$push({ text: 'Задача скопирована' });
      this.close();
    },
    async copyTaskChecklist() {
      const r = await taskApi.fetchItem(this.sourceId, {}, true);
      const { checklist } = r;
      await taskApi.update(this.task, { checklist }, true);

      const route = { name: 'task-detail', params: { projectId: this.project, stageId: this.stage, taskId: this.task } };
      this.$router.push(route).catch(() => { this.$router.go(); });
      this.$push({ text: 'Чеклист скопирован' });
      this.close();
    },
  },
};
</script>

<template lang="pug">
  BasePopup(@close="close()" v-if="isOpened")
    .b-task-copy-popup
      BaseSelect(v-model="project" :options="projectOptions" label="Выберите проект")
      BaseSelect(v-model="stage" v-if="mode === 'task' || mode === 'checklist'" :options="stageOptions" label="Выберите раздел")
      BaseSelect(v-model="task" v-if="mode === 'checklist'" :options="taskOptions" label="Выберите задачу")
      Btn(v-if="mode === 'stage'" :disabled="!project" @click="copyStage") Копировать раздел
      Btn(v-if="mode === 'task'" :disabled="!stage" @click="copyTask") Копировать задачу
      Btn(v-if="mode === 'checklist'" :disabled="!task" @click="copyTaskChecklist") Копировать чеклист

</template>

<style scoped lang="scss">
.task-copy-popup {
  display: grid;
  gap: 30px;
}
</style>
